import { ERROR_MSG_FIELD_FORMAT_INCORRECT, ERROR_MSG_FIELD_REQUIRED } from './patterns'

const getMaxLengthErrorMessage = (value: number) => `Excede el máximo de ${value} caracteres.`

export const generateOptions = (optional: boolean, pattern: RegExp, value: number) => ({
    required: optional ? false : ERROR_MSG_FIELD_REQUIRED,
    pattern: {
        value: pattern,
        message: ERROR_MSG_FIELD_FORMAT_INCORRECT
    },
    maxLength: {
        value: value,
        message: getMaxLengthErrorMessage(value)
    }
})
